import React from "react"
import { AppBulkEditAction } from "@components"

import { useUserSettingsWebSupplierGroup, useUserSettingsWebSupplierGroupValidator } from "../../@hooks"


export default function WebSupplierGroupDrawerSubmit() {
	const { isLoading, handleSubmitFormData } = useUserSettingsWebSupplierGroup()
	const { isValid } = useUserSettingsWebSupplierGroupValidator()

	return <AppBulkEditAction
		loading={isLoading}
		disabled={!isValid}
		onClick={handleSubmitFormData}
	>
		Save
	</AppBulkEditAction>
}